import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && _ctx.landing_pages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("h2", null, "Landing Pages")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "bg-secondary text-white" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Title"),
                    _createElementVNode("th", null, "-")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landing_pages, (landing_page) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: landing_page.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(landing_page.short_name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: ($event: any) => (_ctx.router.push({name:'management.partner',params:{partner_id:landing_page.id}}))
                        }, "View", 8, _hoisted_5)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : (_ctx.err_msg != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}